import { useNavigate } from "react-router-dom";
import Edit2FillIcon from "remixicon-react/Edit2FillIcon";

export const ReviewFlagPill = ({ value }: { value: any }) => {
    const isTrue = value === true || value === "true";
    return (
        <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[11px] font-medium border ${isTrue ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"}`}>
            {isTrue ? "True" : "False"}
        </span>
    );
};

const ReviewModerationItem = (props: any) => {
    const navigate = useNavigate();
    const { review } = props;

    const editReviewHandler = () => {
        navigate(`/review/${review.id}`)
    }

    return (
        <tr className="[&:nth-child(odd)]:bg-[#f7f7f7]">
            <td className="px-4 py-3 text-left text-xs">
                <button onClick={editReviewHandler} className="text-blue-600 hover:text-blue-800 font-medium">
                    {review.id}
                </button>
            </td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{review.productMsn || "—"}</td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{review.userName} {review.userId}</td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{review.rating}</td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{review.reviewSubject || "—"}</td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{review.reviewText || "—"}</td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
                <ReviewFlagPill value={review.isActive} />
            </td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
                <ReviewFlagPill value={review.isApproved} />
            </td>
            <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] whitespace-nowrap">
                {review.created}<br />{review.modified}
            </td>
            <td className="px-4 py-3">
                <button
                    onClick={editReviewHandler}
                    className="text-blue-600 hover:text-blue-800 transition-colors"
                    title="Update"
                >
                    <Edit2FillIcon size={16} />
                </button>
            </td>
        </tr>
    )
}

export default ReviewModerationItem;
